import { IListObj } from "../../../components/types/genericTypes";

export const APITypes: Array<IListObj> = [
  { value: "AV", display: "REST API" },
  { value: "V", display: "Publisher API" },
];

export const isAlgoVendors: Array<IListObj> = [
  { value: true, display: "Algo" },
  { value: false, display: "Non Algo" },
];

export interface SubscriptionFrom {
  appNm: string;
  rdUrl: string;
  appIcon?: any;
  iconView?: any;

  type: string | number | boolean;
  primaryIp: any;
  secondaryIp: any;
  ipEditable: boolean;

  isAlgoVendor: boolean | string; // Can be boolean or empty string
}

export const getAppIcon = (
  appIcon: any,
  readerIcon: (val: string) => void
) => {
  const reader = new FileReader();
  reader.readAsDataURL(appIcon);
  reader.onload = async (e: any) => {
    readerIcon(await e.target.result.split(",")[1]);
  };
};

export const TITLE = {
  EDIT: "Edit Subscription",
  CREATE: "Create Subscription",
};

export interface SubscriptionFromErr {
  appNm?: string;
  rdUrl?: string;
  type?: string;
  appIcon?: string;
  primaryIp?: any;
  secondaryIp?: any;
  isAlgoVendor?: string;
}

export const SubscriptionFromValue: SubscriptionFrom = {
  appNm: "",
  rdUrl: "https://127.0.0.1/",
  type: APITypes[0].value,
  primaryIp: "",
  secondaryIp: "",
  ipEditable: true,
  isAlgoVendor: "", // Empty string initially
};

export const SubscriptionFromError: SubscriptionFromErr = {
  appNm: "",
  rdUrl: "",
  type: "",
  appIcon: "",
  primaryIp: "",
  secondaryIp: "",
  isAlgoVendor: "",
};